import { render, staticRenderFns } from "./RegisterFamily.vue?vue&type=template&id=05c1a302&scoped=true&"
import script from "./RegisterFamily.vue?vue&type=script&lang=js&"
export * from "./RegisterFamily.vue?vue&type=script&lang=js&"
import style0 from "./RegisterFamily.vue?vue&type=style&index=0&id=05c1a302&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c1a302",
  null
  
)

export default component.exports